module.exports = __webpack_public_path__ + "img/40_37_022_620.8766b1b2.jpg";